<template>
    <div class="container">
         <div class="row no-gutters height-self-center">
            <div class="col-sm-12 text-center align-self-center">
               <div class="iq-error position-relative">
                     <img src="/assets/images/error/404.png" class="img-fluid iq-error-img" alt="">
                     <h2 class="mb-0 mt-4">Oops! This page cannot be found.</h2>
                     <p>This page request does not exist.</p>
                     <router-link class="btn btn-primary d-inline-flex align-items-center mt-3" to="/"><i class="ri-home-4-line"></i>Back to Home</router-link>
               </div>
            </div>
         </div>
   </div>
</template>